import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function fileUrl(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatPrice(price, priceType) {
  if (priceType === "Price on Request") return "Price on Request";
  if (!price || price <= 0) return "Price on Request";
  const formatted = new Intl.NumberFormat("en-IN").format(price);
  return `₹ ${formatted}${priceType === "Negotiable" ? "" : ""}`;
}

export const CONDITIONS = ["Excellent", "Very Good", "Good", "Average", "Needs Repair", "For Parts"];
export const SPARE_CONDITIONS = ["New", "Used", "Refurbished"];
export const PRICE_TYPES = ["Fixed", "Negotiable", "Price on Request"];
export const SELLER_TYPES = ["Individual Seller", "Manufacturer", "Dealer", "Distributor", "Supplier"];
export const LISTING_TYPES = [
  { value: "new", label: "New Machine" },
  { value: "used", label: "Used Machine" },
  { value: "spare", label: "Spare Part" },
];

export function listingBasePath(listingType) {
  if (listingType === "new") return "/new-machines";
  if (listingType === "spare") return "/spare-parts";
  return "/used-machines";
}

export function listingNoun(listingType) {
  if (listingType === "spare") return "spare part";
  return "machine";
}
export const STATUSES = [
  { value: "available", label: "Available" },
  { value: "sold", label: "Sold" },
  { value: "not_active", label: "Hidden" },
];
